<template>
  <div class="my-4">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field 
      label="New measurement field label" 
      box 
      v-model="field.label"
      :rules="nameRules"
      ></v-text-field>
      <v-textarea
        v-model="field.description"
        label="Measurement description"
        box
        :rules="nameRules"
        auto-grow
        required
      ></v-textarea>
      <label for="avatar">Choose a measurement image:</label>
      <v-btn color="success" @click="$refs.fileS.click()">Add Image</v-btn>
      <input v-show="false" id="avatar" ref="fileS" type="file" @change="addFile"> 
      <span  v-show="error" class="error--text">The image is required!</span>
      <span  v-show="!error" class="success--text">{{ this.field.file.name }}</span>
      <br>
      <v-btn color="primary" @click="change">Add Field</v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
     error:false,
     valid:false,
      field: {
        label: "",
        description: "",
        file: "",
        type: "input",
        id: ""
      },
      nameRules: [
        v => !!v || 'This field is required!',
        v => (v && v.length >= 5) || 'This field must contain at least 5 letters!'
      ],
      fileRules: [
        v => !!v || 'This field is required!',
      ],
    };
  },
  methods: {
    addFile() {
      this.error = false;
      if(this.$refs.fileS.files[0]){
       this.field.file = this.$refs.fileS.files[0]; 
      }
      else{
        this.error = true;  
      }
    },
    change() {
        if(this.$refs.form.validate() && this.field.file){
            this.field.id = this.field.label.replace(/\s|\//gi, "");
            this.$emit("fieldChange", this.field);
            this.$refs.form.reset(); 
            this.field.file = '';  
        }
        else{
            this.error = true; 
        }
    }
  }
};
</script>

<style>
</style>
